var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from "react";
import { httpClient } from '../services/http/httpClient';
import { createSort, getFieldMetaAttributeFromStorage, setFieldMetaAttributeInStorage, convertTableData, tableDebug, structureFieldMeta } from "./Utils";
import Table from "./Table";
import { Placeholder, TsDataSource } from "../index";
import { useEffectUpdate } from "../hooks/useEffectUpdate";
import { generateFilter, filterHasUpdated, resetFiltersBelow } from "../filtering/Utils";
function RemoteTable(props) {
    var _this = this;
    var id = props.id, endpoint = props.endpoint, baseUrl = props.baseUrl, fields = props.fields, basic = props.basic, forceUpdate = props.forceUpdate, zone = props.zone, setZone = props.setZone, defaultSort = props.defaultSort, noFilter = props.noFilter, noPagination = props.noPagination, noSorting = props.noSorting, noConfigModal = props.noConfigModal, noDownload = props.noDownload, rowSelection = props.rowSelection, debug = props.debug;
    var ds = new TsDataSource({ baseUrl: baseUrl });
    var height = (props.height !== undefined) ? props.height : "100%";
    // data and field information
    var _a = useState([]), data = _a[0], setData = _a[1];
    var _b = useState(null), fieldMeta = _b[0], setFieldMeta = _b[1];
    // pagination
    var getPageSize = function () {
        var _a;
        var size = getFieldMetaAttributeFromStorage(id, fields, 'pageSize');
        return (_a = size !== null && size !== void 0 ? size : props.pageSize) !== null && _a !== void 0 ? _a : 50;
    };
    var _c = useState(1), page = _c[0], setPage = _c[1];
    var _d = useState(getPageSize()), pageSize = _d[0], setPageSize = _d[1];
    var _e = useState(0), totalSize = _e[0], setTotalSize = _e[1];
    // filtering/sorting
    var _f = useState({}), filter = _f[0], setFilter = _f[1];
    var _g = useState(''), sortColumn = _g[0], setSortColumn = _g[1];
    var _h = useState('asc'), sortType = _h[0], setSortType = _h[1];
    // loading, error and warning info
    var _j = useState(true), loading = _j[0], setLoading = _j[1];
    var _k = useState(true), initialLoad = _k[0], setInitialLoad = _k[1];
    var _l = useState(''), error = _l[0], setError = _l[1];
    var handleSortColumn = function (sortColumn, sortType) {
        setSortColumn(sortColumn);
        setSortType(sortType);
    };
    useEffect(function () {
        var compoundedFilter = generateFilter(zone, id);
        // will trigger [filter] useEffect if update has occured
        filterHasUpdated(setFilter, filter, compoundedFilter);
        // resetFiltersBelow({id: id, zone: zone!}); occurs in <Filter />: onFilter()
    }, [zone]);
    useEffectUpdate(function () {
        renderTable();
    }, [page, sortColumn, sortType, filter, forceUpdate]);
    useEffectUpdate(function () {
        setFieldMetaAttributeInStorage(id, pageSize, 'pageSize');
        if (page === 1)
            renderTable();
        // setting page then triggers renderTable in useEffect above
        setPage(1);
    }, [pageSize]);
    var modalOnSave = function (fieldMeta) {
        setFieldMeta(fieldMeta);
        resetFiltersBelow({
            id: id, zone: zone,
            indexOffset: -1
        });
        setZone(__assign({}, zone));
        // setting localFilter then triggers renderTable in useEffect above
        setFieldMetaAttributeInStorage(id, fieldMeta.data, 'data');
        setFieldMetaAttributeInStorage(id, fieldMeta.order, 'order');
    };
    var renderTable = function () {
        setLoading(true);
        // generating query params
        var params = {
            page: page,
            page_size: pageSize,
            filter: filter
        };
        // deal with sorting
        if (sortColumn !== '') {
            params['sort_by'] = createSort(sortColumn, sortType);
        }
        else if (defaultSort !== undefined) {
            params['sort_by'] = defaultSort;
        }
        // get data and update state
        httpClient().get('/' + endpoint, {
            params: params,
            baseURL: baseUrl
        }).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
            var apiData, apiMeta, entityMeta, _a, savedFieldMeta;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        // error if endpoint doesn't return 200
                        if (res.status !== 200)
                            throw Error();
                        apiData = res.data.data;
                        apiMeta = res.data.meta;
                        if (!(basic !== true && initialLoad)) return [3 /*break*/, 2];
                        return [4 /*yield*/, ds.getEntityMeta()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = undefined;
                        _b.label = 3;
                    case 3:
                        entityMeta = _a;
                        setPage(page);
                        setTotalSize(apiMeta.total);
                        setError('');
                        savedFieldMeta = getFieldMetaAttributeFromStorage(id, fields);
                        if (savedFieldMeta === null) {
                            savedFieldMeta = structureFieldMeta(endpoint, entityMeta, fields, props.pageSize);
                            setFieldMetaAttributeInStorage(id, savedFieldMeta);
                        }
                        setFieldMeta(savedFieldMeta);
                        setPageSize(savedFieldMeta.pageSize);
                        // debug logs if prop defined
                        tableDebug(apiData, savedFieldMeta, debug);
                        // setting data using fieldMeta
                        setData(convertTableData(apiData, savedFieldMeta, baseUrl));
                        setLoading(false);
                        setInitialLoad(false);
                        return [2 /*return*/];
                }
            });
        }); }).catch(function (error) {
            setError('Apologies, an error occurred');
            setLoading(false);
            setInitialLoad(false);
            setData([]);
            console.warn(error);
            console.warn('Please ensure the db has been restored');
            console.warn('Please ensure the \'endpoint\' prop is correct and pluralised');
        });
    };
    if (error !== '') {
        return (_jsx(Placeholder, { errorMessage: error, height: height }));
    }
    if (initialLoad) {
        return _jsx(Placeholder, { loader: true, height: height });
    }
    return (_jsx(Table, { id: id, data: data, fieldMeta: fieldMeta, height: height, loading: loading, endpoint: endpoint, baseUrl: baseUrl, page: page, setPage: setPage, pageSize: pageSize, setPageSize: setPageSize, totalSize: totalSize, sortColumn: sortColumn, sortType: sortType, defaultSort: defaultSort, handleSortColumn: handleSortColumn, zone: zone, setZone: setZone, filter: filter, modalOnSave: modalOnSave, noFilter: noFilter, noPagination: noPagination, noSorting: noSorting, noConfigModal: noConfigModal, noDownload: noDownload, rowSelection: rowSelection }));
}
export default RemoteTable;
